import React, { useState } from "react";
import Body from "./Body";

const Hostel = () => {
  const [filter, setFilter] = useState({
    gender: "all",
  });
  const [classesFilter, setClassesFilter] = useState([]);
  
  const [changeHostelPage, setChangeHostelPage] = useState(false);
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [viewDetailsModalFilters, setViewDetailsModalFilters] = useState({
    floor: "",
    room: "",
    isStaffs: false,
  });
  const [addHostelModal, setAddHostelModal] = useState(false);

  const _this = {
    filter,
    setFilter,
    classesFilter,
    setClassesFilter,
    changeHostelPage,
    setChangeHostelPage,
    viewDetailsModal,
    setViewDetailsModal,
    viewDetailsModalFilters,
    setViewDetailsModalFilters,
    addHostelModal,
    setAddHostelModal,
  };

  return <Body {..._this} />;
};

export default Hostel;
